<mat-drawer-container class="sidebar-container">
    <mat-drawer class="sidebar-drawer" opened="true" position="end" mode="side" #drawer>
        <div class="sidebar-content">
            <ng-container *ngTemplateOutlet="dynamicContent"></ng-container>
        </div>
    </mat-drawer>
</mat-drawer-container>